module.exports = __webpack_public_path__ + "static/media/fendt-isobus.0ce170fc.png";